// extracted by mini-css-extract-plugin
module.exports = {"root":"outlookLink_root__1EnYP"};